import { render } from "./GlobalNotifications.vue?vue&type=template&id=c5a228ec"
import script from "./GlobalNotifications.vue?vue&type=script&lang=js"
export * from "./GlobalNotifications.vue?vue&type=script&lang=js"

import "./GlobalNotifications.vue?vue&type=style&index=0&id=c5a228ec&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__